<template>
  <div id="app">
    <router-view v-if="ready"></router-view>
  </div>
</template>

<script>
import { clearGatewayRedirectFlag, consumeGatewayRedirectTarget, extractAuthFailure, fetchGatewaySession, hasRecentGatewayRedirect, redirectToGatewayLogin, refreshGatewayAccessToken } from '@/utils/auth'
import { useSessionStore } from '@/store/session'
import { pinia } from '@/store'

export default {
  name: 'App',
  data() {
    return {
      ready: false,
    }
  },
  methods: {
    clearSession() {
      useSessionStore(pinia).clear()
    },
    applyGatewaySession(data) {
      if (!data) return
      const session = useSessionStore(pinia)
      session.applyGatewayProfile(data)
    },
    async bootstrapSession() {
      const failure = extractAuthFailure(window.location.search)
      if (failure && this.$route.path !== '/login-failed') {
        this.clearSession()
        await this.$router.replace({ path: '/login-failed', query: failure })
        this.ready = true
        return
      }
      if (this.$route.path === '/login-failed') {
        this.ready = true
        return
      }

      const refreshed = await refreshGatewayAccessToken()
      if (refreshed.status === 200 && refreshed.data) {
        this.applyGatewaySession(refreshed.data)
      }

      const session = await fetchGatewaySession()
      if (session.status === 200 && session.data) {
        this.applyGatewaySession(session.data)
        clearGatewayRedirectFlag()
        const target = consumeGatewayRedirectTarget()
        if (target && target !== window.location.pathname + window.location.search && this.$route.path === '/login') {
          window.location.replace(target)
          return
        }
        this.ready = true
        return
      }

      this.clearSession()
      if (hasRecentGatewayRedirect()) {
        clearGatewayRedirectFlag()
        await this.$router.replace({
          path: '/login-failed',
          query: {
            reason: session.status === 403 ? 'forbidden' : 'gateway_session_unavailable',
            message: session.message || '统一认证后仍未建立有效会话',
          },
        })
        this.ready = true
        return
      }

      redirectToGatewayLogin(window.location.pathname + window.location.search)
    }
  },
  async mounted() {
    await this.bootstrapSession()
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  height: 100%;
  background-color: #f0f2f5;
}
</style>
